import{ERROR_CATEGORY_CHILDREN}from"../constants";/**
 * Dispatches the ERROR_CATEGORY_CHILDREN action.
 * @param {string} categoryId The ID of the category to receive children for.
 * @return {Object} The ERROR_CATEGORY_CHILDREN action.
 */var errorCategoryChildren=function errorCategoryChildren(categoryId){return{type:ERROR_CATEGORY_CHILDREN,categoryId:categoryId};};export default errorCategoryChildren;